import { clearSelection } from '@/core/shared'

function DragObject (sourceElement, dragElementStyle, onSuccessFunction) {
	this.dragElement
	this.mouseOffsetFunction
	var mouseOffset
	var displayMode

	sourceElement.dragObject = this

	this.dragElementInit = function () {
		this.dragElement = $(sourceElement).clone().appendTo('body')
		this.dragElement.addClass(dragElementStyle)
		var userData = $(sourceElement).data('data')
		if (userData) {
			this.dragElement.data('data', userData)
		}
	}

	this.dragElementRemove = function () {
		$(this.dragElement).remove()
	}

	this.onDragStart = function (offset) {
		mouseOffset = offset
	}

	this.onDragMove = function (x, y) {
		this.dragElement[0].style['top'] = y - mouseOffset.y + 'px'
		this.dragElement[0].style['left'] = x - mouseOffset.x + 'px'
	}

	this.onDragSuccess = function (dropTarget) {
		if (onSuccessFunction) {
			onSuccessFunction(this.dragElement, dropTarget)
		}
		this.dragElementRemove()
	}

	this.onDragFail = function () {
		this.dragElementRemove()
	}

	this.hideDragElement = function () {
		displayMode = this.dragElement[0].style['display']
		this.dragElement[0].style['display'] = 'none'
	}

	this.showDragElement = function () {
		this.dragElement[0].style['display'] = displayMode
	}

	this.setMouseOffsetFunction = function (offsetFunction) {
		this.mouseOffsetFunction = offsetFunction
	}
}

export function DropTarget (targetElement, dropTargetStyle, onAcceptFunction) {

	targetElement.dropTarget = this

	this.canAccept = function (dragObject) {
		return true
	}

	this.accept = function (dragObject) {
		this.onLeave()
		if (onAcceptFunction) {
			onAcceptFunction(dragObject.dragElement, targetElement)
		}
	}

	this.onLeave = function () {
		$(targetElement).removeClass(dropTargetStyle)
	}

	this.onEnter = function () {
		$(targetElement).addClass(dropTargetStyle)
	}

}

export var dragMaster = (function () {

	var dragObject
	var mouseDownInfo
	var offsetToDrag = 5
	var step = false
	var bodyOverflowX

	var currentDropTarget

	function mouseDown (e, source) {
		if (e.which == 1) {
			var element = source ? source : this
			mouseDownInfo = {
				x: e.pageX,
				y: e.pageY,
				element: element
			}
			fixBodyStyle()
			setDocumentEventHandlers()
			//return false;
		}
	}

	function mouseMove (e) {
		if (mouseDownInfo) {
			if (Math.abs(mouseDownInfo.x - e.pageX) < offsetToDrag &&
				Math.abs(mouseDownInfo.y - e.pageY) < offsetToDrag) {
				return false
			}
			var sourceElement = mouseDownInfo.element
			dragObject = sourceElement.dragObject
			dragObject.dragElementInit()
			var offset = !dragObject.mouseOffsetFunction ?
				getDefaultOffset(sourceElement, mouseDownInfo.x, mouseDownInfo.y) :
				dragObject.mouseOffsetFunction(sourceElement, dragObject.dragElement, e)
			mouseDownInfo = null
			dragObject.onDragStart(offset)
		}
		dragObject.onDragMove(e.pageX, e.pageY)
		step = !step
		if (!step) {
			return false
		}
		var newTarget = getCurrentTarget(e)

		if (currentDropTarget != newTarget) {
			if (currentDropTarget) {
				currentDropTarget.onLeave()
			}
			if (newTarget) {
				newTarget.onEnter()
			}
			currentDropTarget = newTarget
		}
		return false
	}

	function mouseUp () {
		if (!dragObject) {
			mouseDownInfo = null
		} else {
			if (currentDropTarget) {
				currentDropTarget.accept(dragObject)
				dragObject.onDragSuccess(currentDropTarget)
			} else {
				dragObject.onDragFail()
			}
			dragObject.dragElement = null
			dragObject = null
		}
		unfixBodyStyle()
		removeDocumentEventHandlers()
	}

	function getDefaultOffset (element, x, y) {
		var elementOffset = {
			top: Math.round($(element).offset().top),
			left: Math.round($(element).offset().left)
		}
		return {
			x: x - elementOffset.left,
			y: y - elementOffset.top
		}
	}

	function getCurrentTarget (e) {
		var x = e.clientX
		var y = e.clientY

		dragObject.hideDragElement()
		var element = document.elementFromPoint(x - document.body.scrollLeft,
			y - document.body.scrollTop)
		dragObject.showDragElement()
		while (element) {
			if ((element.dropTarget && element.dropTarget.canAccept(dragObject))) {
				return element.dropTarget
			}
			element = element.parentNode
		}
		return null
	}

	function returnFalse () {
		return false
	}

	function setDocumentEventHandlers () {
		$(document).bind('mousemove', mouseMove)
		$(document).bind('mouseup', mouseUp)
		$(document).bind('dragstart', returnFalse)
		$(document.body).bind('selectstart', returnFalse)
		$(window).bind('blur', cancel)
	}

	function removeDocumentEventHandlers () {
		$(document).unbind('mousemove', mouseMove)
		$(document).unbind('mouseup', mouseUp)
		$(document).unbind('dragstart', returnFalse)
		$(document.body).unbind('selectstart', returnFalse)
		$(window).unbind('blur', cancel)
	}

	function fixBodyStyle () {
		bodyOverflowX = $(document.body).css('overflow-x')
		$(document.body).css('overflow-x', 'hidden')
		if ($('body').css('-moz-user-select')) {
			$('body').css('-moz-user-select', 'none')
		}
	}

	function unfixBodyStyle () {
		$(document.body).css('overflow-x', bodyOverflowX)
		if ($('body').css('-moz-user-select')) {
			$('body').css('-moz-user-select', 'auto')
		}
	}

	function cancel () {
		if (dragObject) {
			dragObject.onDragFail()
			dragObject.dragElement = null
			dragObject = null
			if (currentDropTarget) {
				currentDropTarget.onLeave()
			}
		}
		unfixBodyStyle()
		removeDocumentEventHandlers()
		clearSelection()
	}

	return {
		makeDraggableRow: function (element, dragElementStyle, onSuccessFunction, e) {
			new DragObject(element, 'table-row-drag', null)
				.setMouseOffsetFunction(widthRelativeOffset)
			mouseDown(e, element)
		}
	}
}())

function widthRelativeOffset (sourceElement, dragElement, e) {
	return {
		x: Math.round($(dragElement).width() *
			(e.pageX - $(sourceElement).offset().left) / $(sourceElement).width()),
		y: Math.round($(dragElement).height() * 0.5)
	};
}
